export default function contentModalController($uibModalInstance, $sce, item, content, hideHeader) {
    angular.extend(this, {
        image: item.image,
        name: item.name,
        hideHeader: hideHeader,
        content: $sce.trustAsHtml(content),

        ok: function () {
            $uibModalInstance.close();
        }
    });
};